// extracted by mini-css-extract-plugin
export default {"addButtonWrap":"_4064b537edeb4393","tableWrapper":"bcb11a6461d9dd9c"};